import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import Select from 'react-select';
import useWindowSize from './useWindowSize';
import { connect, useDispatch, useSelector } from 'react-redux';
import { newServicesAction } from "../../_actions";
// import './Filters.css';

const teamOptions = [
  { value: 'any', label: 'Any team member' },
  // Add more team members as needed
];

const enabledOptions = [
  { value: 'true', label: 'Enabled' },
  { value: 'false', label: 'Disabled' },
];

const FiltersPopup = forwardRef(function FiltersPopup(props, ref) {
  // console.log("props?.user?.userInfo?.hairdresser?.isSalonOwner",props?.user?.userInfo?.hairdresser?.isSalonOwner)
  const dispatch =useDispatch()
  const [teamMember, setTeamMember] = useState(props?.filters?.teamMember ? {
    value: props?.filters?.teamMember,
    label: props?.filters?.teamMemberName
  } : null);
  const [teamMemberName, setTeamMemberName] = useState(null);
  const [servicesEnabled, setServicesEnabled] = useState(props?.filters?.servicesEnabled ? {
    value: props?.filters?.servicesEnabled,
    label: props?.filters?.servicesEnabled === 'true' ? 'Enabled' : 'Disabled'
  } : null);
  const [onlineBookings, setOnlineBookings] = useState(props?.filters?.onlineBookings ? {
    value: props?.filters?.onlineBookings,
    label: props?.filters?.onlineBookings === 'true' ? 'Enabled' : 'Disabled'
  } : null);
  const [listHairdresserData ,setListHairdresserData] = useState([])
  const { width } = useWindowSize();
  // Mobile hardcoded 'top', so the menu always opened upward regardless of room.
  // In the filters sheet the first control sits near the top, so the list opened
  // into the sheet header and was clipped. 'auto' lets react-select measure and
  // flip; desktop keeps its existing 'bottom'.
  const menuPlacementPosition = width > 991 ? 'bottom' : 'auto';
  // const listHairdresser = useSelector(state => state.newServices.listHairdresser);
    



  const teamOptions = listHairdresserData?.map(hairdresser => ({
    value: hairdresser._id, 
    label: hairdresser.name 
  }));
  // console.log("teamOptions" ,teamOptions,enabledOptions)
  useImperativeHandle(ref, () => ({ apply: handleApply }));

  const handleApply = () => {
    const selectedFilters = {
      teamMemberName: teamMember?.label || props?.filters?.teamMemberName,
      teamMember: teamMember?.value || props?.filters?.teamMember,
      servicesEnabled: servicesEnabled?.value || props?.filters?.servicesEnabled,
      onlineBookings: onlineBookings?.value || props?.filters?.onlineBookings,
    };
    const mergedFilters = {
      ...props?.filters,  
      ...selectedFilters  ,
       searchQuery: props?.filters?.searchQuery || ""
    };

    props.servicesList(mergedFilters);
    props.onSend(mergedFilters);
    props.onHide();
    
    
   
  };

    // Update states when props.filters changes
    useEffect(() => {
      if (props?.filters) {
        // Update teamMember
        if (props.filters.teamMember) {
          setTeamMember({
            value: props.filters.teamMember,
            label: props.filters.teamMemberName
          });
        }
  
        // Update servicesEnabled
        if (props.filters.servicesEnabled) {
          setServicesEnabled({
            value: props.filters.servicesEnabled,
            label: props.filters.servicesEnabled === 'true' ? 'Enabled' : 'Disabled'
          });
        }
  
        // Update onlineBookings
        if (props.filters.onlineBookings) {
          setOnlineBookings({
            value: props.filters.onlineBookings,
            label: props.filters.onlineBookings === 'true' ? 'Enabled' : 'Disabled'
          });
        }
      }
    }, [props.filters]);


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? '1px solid #007EA0' : '1px solid #e0e0e0',
      borderRadius: '10px',
      minHeight: '44px',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 126, 160, 0.08)' : 'none',
      background: '#fff',
      cursor: 'pointer',
      transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
      '&:hover': {
        borderColor: state.isFocused ? '#007EA0' : '#ccc',
      },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#999',
      padding: '8px 10px',
      '&:hover': { color: '#666' },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#333',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#aaa',
    }),
    // Portalled to body (see menuPortalTarget) so the sheet's own bounds and
    // overflow can never clip the option list. Above the raised finance modals.
    menuPortal: (provided) => ({ ...provided, zIndex: 100004 }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '12px',
      border: '1px solid #e8e8e8',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04)',
      overflow: 'hidden',
      zIndex: 20,
      marginTop: '4px',
      marginBottom: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '4px',
      maxHeight: '240px',
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '14px',
      padding: '10px 12px',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'background 0.1s ease',
      backgroundColor: state.isSelected ? '#29282D' : state.isFocused ? '#f0f0f0' : '#fff',
      color: state.isSelected ? '#fff' : '#333',
      '&:active': {
        backgroundColor: state.isSelected ? '#29282D' : '#e8e8e8',
      },
    }),
  };
  const getListHairdresseData =()=>{
    let payload = { }
    dispatch(newServicesAction.listHairDresserData(payload))
      .then((res) => {
        console.log("listHairDresserData successfully12121:", res?.listHairdresser);
        setListHairdresserData(res?.listHairdresser)
      })
      .catch((error) => {
        console.error("Error listHairDresserData:", error);
      });
  }
  useEffect(()=>{
    getListHairdresseData()
  },[])



  return (
      <div className="filters-popup">
        {props?.user?.userInfo?.hairdresser?.isSalonOwner==1&&
        <div className="filter-group">
          <label>Team Member</label>
          {/* {console.log("filter_teamMember",props?.filters)} */}
          <Select 
            menuPlacement={menuPlacementPosition}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            classNamePrefix="my-select"
            value={teamMember || teamOptions?.find(option => option?.label === props?.filters?.teamMemberName)}
            onChange={setTeamMember}
            options={teamOptions}
            styles={customStyles}
            placeholder="All Staff"
            isSearchable={false} 
            // menuIsOpen={true}
          />
        </div>
        }
        <div className="filter-group">
          <label>Services Enabled</label>
          <Select 
            menuPlacement={menuPlacementPosition}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            classNamePrefix="my-select"
            // value={servicesEnabled}
            value={servicesEnabled || enabledOptions?.find(option => option?.value === props?.filters?.servicesEnabled)}
            onChange={setServicesEnabled}
            options={enabledOptions}
            styles={customStyles}
            placeholder="All Services"
            isSearchable={false} 
          />
        </div>
        <div className="filter-group">
          <label>Online Bookings</label>
          <Select 
            menuPlacement={menuPlacementPosition}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            classNamePrefix="my-select"
            // value={onlineBookings}
            value={onlineBookings || enabledOptions?.find(option => option?.value === props?.filters?.onlineBookings)}
            onChange={setOnlineBookings}
            options={enabledOptions}
            styles={customStyles}
            placeholder="All Services"
            isSearchable={false} 
          />
        </div>

      </div>
  );
})


function mapStateToProps(state) {
  return {
      ...state
  };
}
export default connect(mapStateToProps, null, null, { forwardRef: true })(FiltersPopup);